/**
 * Array of month names in order.
 * Used for date dropdowns and analytics filtering.
 */
export const MONTHS = Object.freeze([
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const);

/**
 * Generates an array of years from 2019 to the current year.
 * Computed fresh each call to ensure it always includes the current year.
 * Used for date dropdowns and analytics filtering.
 *
 * @returns Array of years from 2019 to the current year
 *
 * @example
 * ```tsx
 * const years = getYears(); // [2019, 2020, 2021, ..., currentYear]
 * ```
 */
const START_YEAR = 2019;

export const getYears = (): readonly number[] => {
  const currentYear = new Date().getFullYear();
  return Object.freeze(
    Array.from({ length: currentYear - START_YEAR + 1 }, (_, i) => START_YEAR + i),
  );
};

/**
 * @deprecated Use getYears() instead. This constant is computed at module load time
 * and may become stale if the app runs across a year boundary.
 */
export const YEARS = getYears();
